import {
  type EventRevisionDto,
  EventRevisionState,
  SourcingEventStatus,
  type SourcingEventV2Dto,
} from "../../../../autogen/bff-api";

// Mirrors `SourcingEventV2.changesEditWholeEvent` on the BFF — keep the two in step.
export const changesEditWholeEvent = (event: SourcingEventV2Dto): boolean =>
  event.eventContext.type === "Private";

export const openChangeDraft = (event: SourcingEventV2Dto): EventRevisionDto | undefined =>
  [...(event.changes ?? [])].reverse().find((c) => c.state === EventRevisionState.Draft);

export const hasChangeInFlight = (event: SourcingEventV2Dto): boolean =>
  (event.changes ?? []).some(
    (c) => c.state === EventRevisionState.Draft || c.state === EventRevisionState.PublicationPending,
  );

export const isEditableInWizard = (event: SourcingEventV2Dto): boolean =>
  event.status === SourcingEventStatus.Draft ||
  (event.status === SourcingEventStatus.Published &&
    changesEditWholeEvent(event) &&
    openChangeDraft(event) !== undefined);
